export const SIDEBAR_WIDTH = 68

export const SIDEBAR_WIDTH_VAR = '--App-sidebar-width'
